import { baseApi } from './baseApi';
import { withDefinedFields } from './apiUtils';

export const subscriberApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubscribers: builder.query({
      query: (groupId) => (groupId ? `/manager/subscribers?group_id=${groupId}` : '/manager/subscribers'),
      providesTags: [{ type: 'Subscriber', id: 'LIST' }],
    }),
    addSubscriber: builder.mutation({
      query: ({ email, groupId, channel }) => ({
        url: '/manager/subscribers',
        method: 'POST',
        body: { email, group_id: groupId, channel },
      }),
      invalidatesTags: (result, error, { groupId }) => [
        { type: 'Subscriber', id: 'LIST' },
        ...(groupId ? [{ type: 'Subscriber', id: `GROUP-${groupId}` }] : []),
      ],
    }),
    updateSubscriber: builder.mutation({
      query: ({ id, email, phone }) => {
        const body = withDefinedFields([
          ['email', email],
          ['phone', phone],
        ]);
        return { url: `/manager/subscribers/${id}`, method: 'PATCH', body };
      },
      invalidatesTags: [{ type: 'Subscriber', id: 'LIST' }],
    }),
    setSubscriberActive: builder.mutation({
      query: ({ id, isActive }) => ({
        url: `/manager/subscribers/${id}/active`,
        method: 'PATCH',
        body: { is_active: isActive },
      }),
      invalidatesTags: [{ type: 'Subscriber', id: 'LIST' }],
    }),
    removeSubscriber: builder.mutation({
      query: (id) => ({ url: `/manager/subscribers/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'Subscriber', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSubscribersQuery,
  useAddSubscriberMutation,
  useUpdateSubscriberMutation,
  useSetSubscriberActiveMutation,
  useRemoveSubscriberMutation,
} = subscriberApi;
